import { testLocalstorage } from 'lib/utils'

export const useLocalstorage = () => {

  const checkLocalstorage = () => testLocalstorage()

  return {
    hasLocalstorage: checkLocalstorage()
  }
}